











































































































































import { Vue, Component } from "vue-property-decorator";
import { bus } from "../main";

@Component
export default class Alert extends Vue {
  private message: string;
  private snackbarSuccess: boolean;
  private snackbarError: boolean;
  private snackbarIncomplete: boolean;
  private snackbarNoDoc: boolean;
  private snackbarWarning: boolean;

  constructor() {
    super();
    this.message = "";
    this.snackbarSuccess = false;
    this.snackbarError = false;
    this.snackbarIncomplete = false;
    this.snackbarNoDoc = false;
    this.snackbarWarning = false;
  }

  created() {
    bus.$on("successfullOperation", (data: any) => {
      this.message = data;
      this.snackbarSuccess = true;
    });

    bus.$on("errorOperation", (data: any) => {
      this.message = data;
      this.snackbarError = true;
    });

    bus.$on("incompleteInfo", () => {
      this.snackbarIncomplete = true;
    });

    bus.$on("warning", (data: any) => {
      this.message = data;
      this.snackbarWarning = true;
    });

    bus.$on("noDoc", (data: any) => {
      this.message = data;
      this.snackbarNoDoc = true;
    });
  }
}
